import React from "react";
import { useWeb3 } from "../../context/Web3Context";
import { shortAddress } from "../../utils/format";

function ConnectButton({ compact = true }) {
  const { account, connect, disconnect, isConnecting, walletName } = useWeb3();

  if (!account) {
    return (
      <button
        type="button"
        className="connect-btn"
        onClick={connect}
        disabled={isConnecting}
      >
        {isConnecting ? (
          <>
            <span className="spinner" />
            <span>Connecting</span>
          </>
        ) : (
          <>🔌 Connect</>
        )}
      </button>
    );
  }

  return (
    <div
      className="wallet-address"
      onClick={disconnect}
      title={`${walletName || "Wallet"} — click to disconnect`}
      style={{ cursor: "pointer" }}
    >
      <span className="wallet-dot" />
      <span>{shortAddress(account, compact ? 3 : 4)}</span>
    </div>
  );
}

export default ConnectButton;
